// components/common/Skeleton/safari/InterestedUsersSkeleton.js
import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const InterestedUsersSkeleton = ({ count }) => {
  return (
    <div className="users_profile d-flex gap-2 align-items-center flex-wrap">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="profileavtar">
          <Skeleton circle width={24} height={24} />
        </div>
      ))}
    </div>
  );
};

export default InterestedUsersSkeleton;
